import React from 'react';

import IconBtn from '../../../modules/icon-btn/icon-btn';
import TableFooterWrapper from '../../../modules/table-footer-wrapper/table-footer-wrapper';
import currencyFormat from '../../../utils/currencyFormat';
import getWordDecl from '../../../utils/getWordDecl';

import MatchingIcon from './icons/matching-icon.svg';
import PaymentIcon from './icons/payment-icon.svg';

interface OrderRealizationsAdjustedFooterProps {
  positionsCount: number;
  sum: number;
  type: 'matching' | 'payment' | 'waiting';
  onSubmit: () => void;
  balanceError?: boolean;
}

const OrderRealizationsAdjustedFooter: React.FC<OrderRealizationsAdjustedFooterProps> = ({
  onSubmit,
  balanceError,
  positionsCount,
  sum,
  type,
}) => {
  const getFooterAction = () => {
    if (type === 'matching') {
      return (
        <IconBtn
          disabled={balanceError}
          onClick={onSubmit}
          icon={MatchingIcon}
          title="Согласовать изменения"
        />
      );
    }
    if (type === 'payment') {
      return (
        <IconBtn
          disabled={balanceError}
          onClick={onSubmit}
          icon={PaymentIcon}
          title="Оплатить"
        />
      );
    }
    return undefined;
  };

  const getErrorBody = () => {
    if (balanceError) {
      return (
        <>
          <div className="table-footer__notice">
            На вашем счете не хватает средств! Пополните баланс
          </div>
          <div className="table-footer__notice-divider">|</div>
        </>
      );
    }
    return null;
  };

  return (
    <TableFooterWrapper
      right={
        <>
          {getErrorBody()}
          <div className="table-footer__desc">
            Изменения по {positionsCount}{' '}
            {getWordDecl(positionsCount, ['позиции', 'позициям', 'позиций'])} на
            сумму:
          </div>
          <div className="table-footer__sum">{currencyFormat(sum)}</div>
          {type !== 'waiting' && (
            <div className="table-footer__action">{getFooterAction()}</div>
          )}
        </>
      }
    />
  );
};

export default OrderRealizationsAdjustedFooter;
